'use strict'

var videojs = require('video.js');
require('es6-promise/auto');

function init() {
	var mastheadVideo = document.getElementById('mastheadVideo');
	if (!mastheadVideo) return;

	function get(url) {
		return new Promise(function (resolve, reject) {
			var xhr = new XMLHttpRequest;
			xhr.open('GET', url);
			xhr.onload = function () {
				if (xhr.status === 200) {
					resolve(xhr.responseText);
				} else {
					reject(Error(xhr.statusText))
				}
			};
			xhr.onerror = function () {
				reject(Error('Network Error'));
			};
			xhr.send();
		});
	}

	var jsonUrl = mastheadVideo.getAttribute('data-json');
	var options = {
		// preload: 'auto',
		// https://jira.plaudit.com/browse/APBOE-823
		// Note: The preload attribute is ignored if autoplay is present.
		preload: 'none',
		loop: true,
		autoplay: true,
		mute: true,
		controls: false,
		sources: []
	};

	get(jsonUrl)
		.then(function (result) {
			return JSON.parse(result).gfyItem;
		}).then(function (response) {
			if (response.webmUrl) {
				options.sources.push({
					src: response.webmUrl,
					type: 'video/webm'
				});
			}
			if (response.mp4Url) {
				options.sources.push({
					src: response.mp4Url,
					type: 'video/mp4'
				});
			}
			var player = videojs(mastheadVideo, options);
		}).catch(function (error) {
			console.warn('The masthead video could not be loaded.');
		});
}

module.exports = {
	init: init
};
